<template>
  <v-form class="order-form" @submit.prevent="onSubmit" ref="form">
    <v-progress-linear
      v-if="ediFormLoading"
      indeterminate
      color="primary"
    ></v-progress-linear>
    <div>
      <InputElement
        v-model="state.nurseBatchNumber"
        :rules="nurseBatchNumberRule"
        label="Šarže sestry pro pozvání pacienta"
      />
      <InputMedicines
        :medicineId="state.nurseBatchNumberMedicineId"
        :rules="medicineInputRule"
        @input="onMedicineInput"
      ></InputMedicines>
      <InputElement
        :rules="[rules.required, rules.email]"
        v-model="state.email"
        label="Email"
      />
      <InputElement
        :rules="[rules.required]"
        v-model="state.firstName"
        label="Jméno"
      />
      <InputElement
        :rules="[rules.required]"
        v-model="state.lastName"
        label="Přijmení"
      />
      <InputElement
        :rules="[rules.required, rules.isNumberBetween0and1000]"
        v-model="state.maxPatientsCount"
        label="Počet pacientů"
      />
      <ButtonElement
        :text="nurseId ? 'Upravit' : 'Pozvat'"
        type="submit"
        :loading="loading"
      ></ButtonElement>
    </div>
  </v-form>
</template>

<script>
import InputElement from "../elements/InputElement.vue";
import useApiCall from "../../use/apiCall";
import validation from "../../use/validations";
import ButtonElement from "../elements/ButtonElement.vue";
import InputMedicines from "../elements/InputMedicines.vue";

export default {
  components: { InputElement, ButtonElement, InputMedicines },
  setup() {
    const { postData, getData, putData } = useApiCall();
    return { postData, getData, putData };
  },

  props: {
    nurseId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      ediFormLoading: false,
      rules: validation,
      state: {
        nurseBatchNumber: null,
        nurseBatchNumberMedicineId: null,
        email: "",
        firstName: "",
        lastName: "",
        maxPatientsCount: "",
      },
    };
  },

  watch: {
    "state.nurseBatchNumber": {
      handler() {
        this.state.nurseBatchNumber = this.state.nurseBatchNumber.toUpperCase();
      },
      deep: true,
    },
    nurseId: {
      async handler() {
        if (this.nurseId) {
          this.ediFormLoading = true;
          const { user } = await this.getData(`users/${this.nurseId}`);
          if (user) {
            this.state.email = user.email;
            this.state.firstName = user.firstName;
            this.state.lastName = user.lastName;
            this.state.maxPatientsCount = user.maxPatientsCount;
            this.state.nurseBatchNumber = user.nurseBatchNumber;
            this.state.nurseBatchNumberMedicineId =
              user.nurseBatchNumberMedicineId;
          }
          this.ediFormLoading = false;
        } else {
          if (this.$refs.form) {
            this.$refs.form.reset();
          }
          this.state.email = "";
          this.state.firstName = "";
          this.state.lastName = "";
          this.state.maxPatientsCount = "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      if (this.nurseId) {
        await this.editNurse();
      } else {
        await this.inviteNurse();
      }
      this.loading = false;
    },

    async inviteNurse() {
      const response = await this.postData(
        "nurses/invite",
        { nurse: this.state },
        null,
        true
      );

      if (response) {
        this.$store.commit("setFormMessages", {
          type: "success",
          texts: ["Sestra byla úspěšně pozvána."],
        });
        this.$emit("closeDialog");
        this.$emit("fetchUsers");
      }
    },

    async editNurse() {
      const payload = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        maxPatientsCount: this.state.maxPatientsCount,
        nurseBatchNumber: this.state.nurseBatchNumber || null,
        nurseBatchNumberMedicineId:
          this.state.nurseBatchNumberMedicineId || null,
      };
      const response = await this.putData(
        `nurses/${this.nurseId}`,
        { nurse: payload },
        null,
        true
      );

      if (response) {
        this.$store.commit("setFormMessages", {
          type: "success",
          texts: ["Sestra byla úspěšně upravena."],
        });
        this.$emit("closeDialog");
      }
    },

    onMedicineInput(medicineId) {
      this.state.nurseBatchNumberMedicineId = medicineId;
    },
  },

  computed: {
    nurseBatchNumberRule() {
      if (this.state.nurseBatchNumberMedicineId) {
        return [this.rules.required];
      } else return [];
    },

    medicineInputRule() {
      if (this.state.nurseBatchNumber) {
        return [this.rules.required];
      } else return [];
    },
  },
};
</script>

<style lang="scss" scoped>
.order-form {
  .button-element {
    width: 100%;
  }
}
</style>
